import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';

import { LinkSyncPipe } from '@ecm/router';

import { CarrouselItemViewModel } from '../../business/model/carrousel-item.view-model';
import { CarrouselStoreService } from '../../store/carrousel-store.service';
import { CarrouselNavAccordionComponent } from '../carrousel-nav-accordion/carrousel-nav-accordion.component';

@Component({
    selector: 'ecm-carrousel-item',
    templateUrl: 'carrousel-item.component.html',
    styleUrls: ['carrousel-item.component.css'],
    standalone: true,
    imports: [CommonModule, CarrouselNavAccordionComponent, LinkSyncPipe, TranslateModule],
})
export class CarrouselItemComponent implements OnInit {
    @Input() public carrouselItem: CarrouselItemViewModel;
    @Input() public selectedLink: string;
    @Input() public carrouselLinksItemsSelected: boolean;
    @Input() public isSosh: boolean;

    public carrouselDetailsTranslate: any;
    public e2e = 'e2e-carrousel-';

    public constructor(
        private readonly translate: TranslateService,
        protected carrouselStore: CarrouselStoreService,
    ) {}

    public ngOnInit() {
        this.carrouselDetailsTranslate = this.translate.instant('details');
    }

    public selectAvatar(item: CarrouselItemViewModel) {
        if (item.type !== 'member') return;

        this.carrouselStore.getIsVerified$.pipe(take(1)).subscribe((isVerified) => {
            const inAppUrl = isVerified
                ? this.carrouselDetailsTranslate.profile.url + item.id
                : this.carrouselDetailsTranslate.gerer_profils.url;

            const avatarButton = {
                ...item.button,
                link: {
                    references: [
                        {
                            linkWeb: { inApp: inAppUrl },
                        },
                    ],
                },
                navigationExtras: { queryParams: {} },
            };
            this.carrouselStore.openLink(avatarButton);
        });
    }
}
